import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Team from "@/pages/Team";

export const Route = createFileRoute("/es/sobre-qbd/equipo")({
  head: () => buildRouteHead("/es/sobre-qbd/equipo"),
  component: Team,
});

